import React, { Component } from 'react';
import { Text } from '../../../lib/base';

export default class None extends Component {
  render() {
    return <Text size="small">None.</Text>;
  }
}
